import { render } from "./pageAbout.vue?vue&type=template&id=40e56317&scoped=true"
import script from "./pageAbout.vue?vue&type=script&lang=js"
export * from "./pageAbout.vue?vue&type=script&lang=js"

import "./pageAbout.vue?vue&type=style&index=0&id=40e56317&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e56317"]])

export default __exports__